import $ from 'jquery';

$('form.publication-filter').each((_, elem) => {
    const $form = $(elem);
    $form.find('.pagination .page-link[href]').on('click', ev => {
        ev.preventDefault();
        $form.attr('action', $(ev.currentTarget).attr('href'));
        $form.trigger('submit');
    });

    $form.on('submit', () => {
        $form.addClass('non-interactive');
    });
});
